import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const TOKEN_KEY = 'exam_token'
const USER_KEY = 'exam_user'

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(TOKEN_KEY) || '',
    user: JSON.parse(localStorage.getItem(USER_KEY) || 'null'),
    loginRedirecting: false
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
    roleCode: state => state.user ? state.user.roleCode : '',
    loginRedirecting: state => state.loginRedirecting
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem(TOKEN_KEY, token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(USER_KEY)
    },
    SET_LOGIN_REDIRECTING(state, redirecting) {
      state.loginRedirecting = redirecting
    }
  },
  actions: {
    saveToken({ commit }, token) {
      commit('SET_TOKEN', token)
      commit('SET_LOGIN_REDIRECTING', false)
    },
    saveUser({ commit }, user) {
      commit('SET_USER', user)
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})
